<!-- else loading -->
@if (isLoading) {
<mat-progress-bar
        color="primary"
        mode="indeterminate">
</mat-progress-bar>
}

@if (merged$ | async; as response ) {
<div>
    @if (!isVideoEditable) {
<div >
        @for (video of response.data ; track $index; let i = $index) {
<div class="wrapper">
            <gtw-video-item (click)="openVideoDialog(video)" [video]=video></gtw-video-item>
            <!--  -->
            @if (isValidUser(video.sso_id)) {
<div class="overlay">
                <mat-card>
                    <div class="edit-buttons">
                        <button mat-icon-button aria-label="Update button" (click)="updateScreenVideo(video)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </div>
                    <div class="edit-buttons">
                        <button mat-icon-button aria-label="Delete button" (click)="confirmDelete(video.video_id)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </mat-card>
            </div>
}
        </div>
}
        @if (response.callSuccess == 1 && response.data.length == 0) {
<div class="noVideos">
            <p>No help videos.@if (canUploadVideos()) {
<span> Please add the video</span>
}</p>
            @if (canUploadVideos()) {
<gtw-video-upload 
                               (cancelDocModal)="cancel()"></gtw-video-upload>
}
        </div>
}
        @if (response.callSuccess == 0) {
<div>
            {{response.errorMessage}}
        </div>
}
    </div>
}
    
</div>
}
@if (isVideoEditable) {
<div>
    <gtw-video-upload
        [updateScreenVideo]="updateScreensVideoInput"
        (refreshScreenVideoList)="refreshScreenVideoList($event);"
        (cancelDocModal)="cancel()"></gtw-video-upload>
</div>
}

